// import { create } from "zustand";
// import { devtools } from "zustand/middleware";

import { create } from "zustand";

// type AuthState = {
//   token: string | null;
//   roles: string[];
//   login: (token: string,  roles: string[]) => void;
//   logout: () => void;
// };

// // export const useAuthStore = create<AuthState>((set) => ({
// //   token: null,
// //   refreshToken: null,
// //   roles: [],
// //   login: (token, refreshToken, roles) =>
// //     set({ token, refreshToken, roles }),
// //   logout: () =>
// //     set({ token: null, refreshToken: null, roles: [] }),
// // }));

// export const useAuthStore = create<AuthState>()(
//   devtools((set) => ({
//     token: null,
//     refreshToken: null,
//     roles: [],
//     login: (token, roles) =>
//       set({ token, roles }, false, 'auth/login'),
//     logout: () =>
//       set({ token: null, roles: [] }, false, 'auth/logout'),
//   }))
// );


const authStore = create((set) => ({
    authData: {
      token: '',
      refreshToken: '',
      roles: []
    },

    updateAuthData: (newData) => {
      set((state) => ({
        authData: { ...state.authData, ...newData },
      }))
    }
}))


export default authStore
